import { render, staticRenderFns } from "./add.vue?vue&type=template&id=3f3c25af&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3c25af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f3c25af')) {
      api.createRecord('3f3c25af', component.options)
    } else {
      api.reload('3f3c25af', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=3f3c25af&scoped=true", function () {
      api.rerender('3f3c25af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/baseSyntheticalManagement/baseProductionData/add.vue"
export default component.exports